import React from "react";

import { ConfigType, WidgetDrawerProps } from "../../../types/widgets";
import { DiscountMessageBoxWidgetAppearanceSettings } from "../DiscountMessageBoxWidgetsTab/DiscountMessageBoxWidgetAppearanceSettings";
import { DiscountProgressBarWidgetAppearanceSettings } from "../DiscountProgressBarWidgetsTab/DiscountProgressBarWidgetAppearanceSettings";
import { DiscountQuantityWidgetAppearanceSettings } from "../DiscountQuantityWidgetsTab/DiscountQuantityWidgetAppearanceSettings";
import { ShippingProgressBarWidgetAppearanceSettings } from "../ShippingProgressBarWidgetsTab/ShippingProgressBarWidgetAppearanceSettings";

type AppearanceSettingsProps = WidgetDrawerProps & { configType: ConfigType };
export const AppearanceSettings = ({
  widgetType,
  configType,
}: AppearanceSettingsProps) => {
  if (widgetType === "quantityButtons") {
    return <DiscountQuantityWidgetAppearanceSettings configType={configType} />;
  }

  if (widgetType === "discountProgressBar") {
    return (
      <DiscountProgressBarWidgetAppearanceSettings configType={configType} />
    );
  }

  if (widgetType === "shippingProgressBar") {
    return (
      <ShippingProgressBarWidgetAppearanceSettings configType={configType} />
    );
  }

  if (widgetType === "messageBoxPopup" || widgetType === "messageBoxSlideOut") {
    return (
      <DiscountMessageBoxWidgetAppearanceSettings configType={configType} />
    );
  }

  return null;
};
